/* eslint-disable no-unused-vars */
import WorkExperienceDotPointDTO from './workExperienceDotPointDTO'
import WorkExperienceDotPointWithIdDTO from './workExperienceDotPointWithIdDTO'

/**
 * @class
 * @public
 */
export default class WorkExperienceUploadFormDTO {
  /**
   * @constructor
   * @param {Object<placeOfWork: String, positionHeld: String, dateFrom: Date, dateUntil: Date, details: String, dotPoints: Array<WorkExperienceDotPointWithIdDTO>, isCurrent: Boolean>, files: Array<File>} param0
   */
  constructor({
    placeOfWork = null,
    positionHeld = null,
    dateFrom = null,
    dateUntil = null,
    details = null,
    dotPoints = [],
    isCurrent = false,
    files = [],
  } = {}) {
    /**
     * @type {String}
     */
    this.placeOfWork = placeOfWork

    /**
     * @type {String}
     */
    this.positionHeld = positionHeld

    /**
     * @type {Date}
     */
    this.dateFrom = dateFrom

    /**
     * @type {Date}
     */
    this.dateUntil = dateUntil

    /**
     * @type {String}
     */
    this.details = details

    /**
     * @type {Array<WorkExperienceDotPointWithIdDTO>}
     */
    this.dotPoints = dotPoints

    /**
     * Indicates if candidate is currently in role
     * @type {Boolean}
     */
    this.isCurrent = isCurrent

    /**
     * @type {Array<File>}
     */
    this.files = files
  }
}
